import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import { Smile } from 'lucide-react';
import { EMOJI_CDN } from './EmojiText';

const Picker = lazy(() => import('emoji-picker-react'));

export const EmojiPicker = ({ onPick }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen((o) => !o)} title="Emojis" className={`p-2 transition-colors ${open ? 'text-amber-500' : 'text-slate-500 hover:text-slate-800'}`} data-testid="chat-emoji-btn"><Smile className="w-5 h-5" /></button>
      {open && (
        <div className="fixed left-3 right-3 bottom-24 sm:absolute sm:bottom-12 sm:left-0 sm:right-auto z-50 shadow-2xl rounded-xl flex justify-center" data-testid="chat-emoji-picker">
          <Suspense fallback={<div className="w-[320px] h-[380px] bg-white rounded-xl border flex items-center justify-center text-xs text-slate-400">A carregar…</div>}>
            <Picker emojiStyle="apple" getEmojiUrl={(u) => `${EMOJI_CDN}${u}.png`} width={Math.min(340, window.innerWidth - 24)} height={400} lazyLoadEmojis searchPlaceholder="Procurar emoji (em inglês)"
              previewConfig={{ showPreview: false }} skinTonesDisabled={false}
              categories={[
                { category: 'suggested', name: 'Recentes' }, { category: 'smileys_people', name: 'Caras e pessoas' }, { category: 'animals_nature', name: 'Animais e natureza' },
                { category: 'food_drink', name: 'Comida' }, { category: 'travel_places', name: 'Viagens' }, { category: 'activities', name: 'Atividades' },
                { category: 'objects', name: 'Objetos' }, { category: 'symbols', name: 'Símbolos' }, { category: 'flags', name: 'Bandeiras' },
              ]}
              onEmojiClick={(d) => onPick(d.emoji)} />
          </Suspense>
        </div>
      )}
    </div>
  );
};
